import { HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { $app } from '@app/app.service'
import { AppBasicService } from '@data/service/app-basic.service'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

@Injectable()
export class ProjectService extends AppBasicService {
   getForTable(): Observable<any> {
      return this.http.get(`${this._configService.apiUrl}/pmp/projects`, this.httpOptions).pipe(
         map((res: any) => {
            return {
               total: res?.total_elements ?? 0,
               data: res?.results?.map((row) => this.dataSrv.mapProject(row)) ?? [],
            }
         })
      )
   }

   getById(projectId: any): Observable<any> {
      return this.http.get(`${this._configService.apiUrl}/pmp/projects/${projectId}/dashboards`, this.httpOptions).pipe(
         map((res: any) => {
            return this.dataSrv.mapProject(res, 'dashboard')
         })
      )
   }

   update(data: any): Observable<any> {
      if (data) {
         const projectId = $app.getCurrentProjectId()

      if (!projectId) return

         let params = data

         return this.http.patch<any>(`${this._configService.apiUrl}/pmp/projects/${projectId}`, params, this.httpOptions)
      }

      return of(false)
   }

   reportingsUpdatable(data: any): Observable<any> {
      if (data) {
         const projectId = $app.getCurrentProjectId()

      if (!projectId) return

         let params = data

         return this.http.post<any>(`${this._configService.apiUrl}/pmp/projects/${projectId}/reportingsUpdatable`, params, this.httpOptions)
      }

      return of(false)
   }

   uploadLogo(file: any): Observable<any> {
      if (file) {
         const projectId = $app.getCurrentProjectId()

      if (!projectId) return

         let params = new FormData()
         params.append('file', file)

         const httpOptions = {
            headers: new HttpHeaders({
               'Cache-control': 'no-cache',
            }),
         }

         return this.http.post<any>(`${this._configService.apiUrl}/pmp/projects/${projectId}/logo`, params, httpOptions)
      }

      return of(false)
   }
}

